import { useForm } from '@mantine/form';

export const useSignInForm = () => {
  return useForm({
    initialValues: {
      username: '',
      password: '',
      terms: true,
    },

    validate: {
      username: (val) => (val.length < 6 ? 'Username should be at least 6 characters long' : null),
      password: (val) => (val.length < 6 ? 'Password should be at least 6 characters long' : null),
    },
  });
};
